angular.module('aprima-core-ui').directive('apDataGroup', function () {
    'use strict';

    return {
        restrict: 'E',
        scope: {
            label: '@',
            value: '@',
            normal: '@'
        },
        templateUrl: '/core-ui/views/directives/apDataGroup.html'
    };
});